import { checkShippingGroup, bindPannel } from './shipping-utils';
import { inputReexListener } from './shipping-reex';
import { init as initSelect } from '../../../commons/select';
import { init as initStateButtonsHandler } from '../state-button-handler';

import { i18n } from '@/commons/utils';

const shippingGroupUrl        = 'rest/model/atg/commerce/order/purchase/CreateInStorePickupShippingGroupActor';
const updateShippingGroupUrl  = `${shippingGroupUrl}/addInStorePickupShippingGroup`;
const setFriendNameUrl        = `${shippingGroupUrl}/setPickupFriendNameInStorePickupShippingGroup`;
const setFriendPhoneUrl       = `${shippingGroupUrl}/setPickupFriendPhoneInStorePickupShippingGroup`;
const pickUpOneHour           = 'rest/model/com/decathlon/cube/commerce/order/purchase/CreateInStorePrepareAndPickupShippingGroupActor/addInStorePrepareAndPickupShippingGroup';


function initPickUpSelect () {
  $('.checkout__shipping__pickup input[type="radio"][name="delivery-type"]:checked').change();
}

function validateInit() {
/* eslint-disable one-var */
  const validationPluginOpts  = $.validator.cubeOptions;

  $('#js-checkout-shipping').validate( $.extend(null, validationPluginOpts, {
    ignore:'',

    messages: {
      inputSelectedName: {
        text: i18n('shippingAddress.error.invalidCharacter')
      },
      inputSelectedPhone: {
        pattern: i18n('validationMsg.phoneCN')
      }
    }
  }));

  // Legacy validate
  const nameInputs  = cube.$$('input[name*="another-person-name-"]'),
    phoneinputs = cube.$$('input[name*="another-person-phone-"]');

  nameInputs.forEach(element => {
    element.addEventListener('blur', validateName);
  });

  phoneinputs.forEach(element => {
    element.addEventListener('blur', validatePhone);
  });

  validateOrInvalidateFriendPicking();
};

function validatePhone () {
/* eslint-disable one-var */
  const validator = $('#js-checkout-shipping').validate(),
    elt = $(this),
    phoneValidation = validator.element(elt);

  if(phoneValidation === true){
    setPhoneShippingGroup();
  }
};

function validateName () {
/* eslint-disable one-var */
  const validator = $('#js-checkout-shipping').validate(),
    elt = $(this),
    nameValidation = validator.element(elt);

  if(nameValidation === true){
    setNameShippingGroup();
  }
};

let setNameShippingGroup = () => {

  const params  = {
    friendPickupName: friendName()
  };

  setFriendNameOrPhoneAjaxCall(setFriendNameUrl, params).catch(err => {
    cube.alert.error(i18n(err.code));
  });
};

function setPhoneShippingGroup () {

  const params  = {
    friendPickupPhone: friendPhone()
  };

  setFriendNameOrPhoneAjaxCall(setFriendPhoneUrl, params).catch(err => {
    cube.alert.error(i18n(err.code));
  });
};

function friendName () {
  const infosWrapper   = cube.$('.checkout__shipping__pickup input[name="delivery-type"]:checked ~ .checkout__shipping__store') || null;

  if(infosWrapper) {
    return infosWrapper.$('.js-pickup-friend-name').value;
  }
  return '';

};

function friendPhone () {
  const infosWrapper   = cube.$('.checkout__shipping__pickup input[name="delivery-type"]:checked ~ .checkout__shipping__store') || null;

  if(infosWrapper) {
    return infosWrapper.$('.js-pickup-friend-phone').value;
  }
  return '';
};

/**
 * Display all stores
 */
function storesLoader (event){
  event.preventDefault();

  const params = {
    '&shortList': 'false',
    otherPersonName : friendName(),
    otherPersonPhone : friendPhone(),
    context: cube.$id('pick-up').dataset.context
  };

  cube.$id('pick-up-details').removeAttribute('data-t-url-actor');

  cube.cartridge('pick-up-details').before(() => {
    cube.ui.displayLoader(event.target);
  }).after(() => {
    cube.event.send('checkout:store-loaded');
    validateInit();
    checkShippingGroup();
    inputReexListener();
    initSelect();
    pickup();

  }).reload(params);
};

function regionsLoader () {

  cube.$id('pick-up-details').removeAttribute('data-t-url-actor');

  /* eslint-disable one-var */
  const params = {
    '&currentLocation': cube.$id('dkt-select-store-selection').value,
    otherPersonName : '',
    otherPersonPhone : '',
    context: cube.$id('pick-up').dataset.context
  };

  cube.cartridge('pick-up-details').after(() => {
    cube.event.send('checkout:store-loaded');
    initSelect();
    initStateButtonsHandler();
    pickup();
    bindPannel();
  }).reload(params);
};

function updateStoreShippingGroup (event) {
/* eslint-disable one-var */
  let postUrl = '';
  if(event.target.nextElementSibling.querySelector('.checkout__shipping__one-hour') === null) {
    postUrl = updateShippingGroupUrl;
  } else {
    postUrl = pickUpOneHour;
  }

  const input   = event.currentTarget;
  sendActor(postUrl, input);
};

function changePickupActor (event) {

  if(event.target.classList.contains('pickup-classic')) {
    // add checked stats on the first input radio because it's remove when you leave the store for another
    $('.pickup-onehour').attr('checked', 'checked');
    // remove checked state from the input C&C 1h
    $(event.target).closest('.checkout__shipping__pickup-choice').find('#pickup-onehour').removeAttr('checked');
  }

  let postUrl = '';
  if(event.target.classList.contains('pickup-onehour')) {
    postUrl = pickUpOneHour;
  } else {
    postUrl = updateShippingGroupUrl;
  }

  const input   = event.currentTarget;
  sendActor(postUrl, input);
}

function sendActor(postUrl, input) {
  const params  = {
    selectedStoreId: input.value,
    shippingMethodOptionId: input.dataset.shippingoptionid,
    friendPickupName: friendName(),
    friendPickupPhone: friendPhone(),
    context: cube.$id('pick-up').dataset.context
  };

  cube.ajax.form(postUrl, params).onSuccess((response) => {
    if(response && response.responseTO && response.responseTO.errors[0] && response.responseTO.errors[0].code) {
      cube.$('.dkt-checkout-primary-button').classList.add('error-shipping');
      cube.alert.error(i18n(response.responseTO.errors[0].code));
      initStateButtonsHandler();
    } else {
      cube.$('.dkt-checkout-primary-button').classList.remove('error-shipping');
      cube.event.send('checkout:refresh-order-summary');
    }
  }).call();
}

function pickup () {

  // See more stores
  if(cube.$id('js-more-stores'))
    cube.$id('js-more-stores').addEventListener('click', storesLoader);

  if(cube.$id('dkt-select-store-selection'))
    cube.$id('dkt-select-store-selection').addEventListener('change', regionsLoader);

  validateInit();
};

const validateOrInvalidateFriendPicking = () => {
  cube.$$('.checkout__shipping__checkbox').forEach(elem => {
    elem.delegate('change', '.js-is-picked', () => {
      if (elem.closest('input[type="checkbox"]') && elem.closest('input[type="checkbox"]').checked) {
        setNameShippingGroup();
        setPhoneShippingGroup();
      } else {
        setFriendNameOrPhoneAjaxCall(setFriendNameUrl, { friendPickupName : '' }).then(() => {
          setFriendNameOrPhoneAjaxCall(setFriendPhoneUrl, { friendPickupPhone : '' }).catch(err => {
            cube.alert.error(i18n(err.code));
          });
        }).catch(err => {
          cube.alert.error(i18n(err.code));
        });
      }
    });
  });
};

const setFriendNameOrPhoneAjaxCall = (url, params) => {
  return new Promise((resolve, reject) => {
    cube.ajax.form(url, params).onSuccess((response) => {
      if(response.responseTO.errors[0] && response.responseTO.errors[0].code) {
        reject(response.responseTO.errors[0])
      } else {
        resolve(response)
      }
    }).call();
  })
};

export { pickup, updateStoreShippingGroup, changePickupActor, initPickUpSelect };



// WEBPACK FOOTER //
// ./src/modules-es5/checkout/shipping/pickup-in-store.js